import React, {useContext, useEffect} from "react";
import {OrderContext} from "../../contexts/OrderContext";
import Order from "../../rest/jtmc/models/Order";
import {storageFunctions} from "../../storage";
import {AppFunctionsContext} from "../../contexts/AppFunctionsContext";

export default function OrderProgressScreenFunction(props: { children: any }) {
    const orderContext = useContext(OrderContext);
    const appFunctions = useContext(AppFunctionsContext);

    useEffect(() => {
        setTimeout(()=>{
            storageFunctions.getData("pwa_manual_installation_showed").then(val=>{
                const showed = Boolean(val);
                if(!showed)
                    appFunctions.functions.openManualPWAInstallPrompt();
            });
        }, 1500);
    }, []);

    useEffect(() => {
        if (orderContext.order == null)
            return;
        const socketAddress = `order.${orderContext.order.id}`;
        // @ts-ignore
        window.Echo.private(socketAddress)
            .listen('OrderStatusChangeEvent', (e: any) => {
                try {
                    const order = new Order(e);
                    orderContext.setOrder(order);
                } catch (e) {
                    console.log(e);
                }
            });
        return () => {
            // @ts-ignore
            window.Echo.leave(socketAddress);
        }
    }, [orderContext.order]);

    return <>
        {props.children}
    </>
}
